import React, { Component } from 'react'

import style from './style.css'

export default class MenuResponsive extends Component {
    render() {
        return (
            <ul className={style.menu}>
                {this.props.children}
                <li className={style.end} />
            </ul>
        )
    }
}

export class Item extends Component {
    render() {
        return (
            <li className={(this.props.active) ? style.active : ''}>
                {this.props.children}
            </li>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/atoms/MenuResponsive/index.js